import React from 'react';

function DefaultInput(props: any) {
  return (
    <form className={style.form}>
      <div className="relative">
        <div className={style.parent}>
          <svg
            className={style.svg}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
            />
          </svg>
        </div>
        <input
          id="search"
          value={props.value}
          onChange={props.onChangeHandler}
          type="search"
          className={style.input}
          placeholder={props.placeholder !== null ? props.placeholder : 'جستجو'}
        />
      </div>
    </form>
  );
}

const style = {
  form: 'w-[50%] mx-auto',
  parent:
    'absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none',
  svg: 'w-4 h-4 text-gray-500',
  input:
    'shadow-md block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500',
};

export default DefaultInput;
